import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DatePicker, Select, Button, message } from 'antd';
import 'antd/dist/reset.css';
import './rep-abon-report-header.css'
import RepAbonFilter from "./rep-abon-filter"
import { ExportExcelButton, isMobile, PrintButton } from '../../../extensions/design';
import { useExcelData } from '../rep-excel-data-provider';
import { exportToExcel } from '../../../controls/export-to-excel/export-to-excel';


// Шапка финансового отчета с фильтрами по датам, по кассам, по типам сортировки
function RepAbonReportHeader({ filters, onFilterChange, periodType, employeeType, products, onRefresh }) {
  const navigate = useNavigate();
  const [page, setPage] = useState("abon");
  const [showFilter, setShowFilter] = useState(false);
  const { excelDataTotal, excelData } = useExcelData();
  useEffect(() => {
    if (excelDataTotal || excelData) {
      console.groupCollapsed("%c[RepAbonReportHeader] Получены данные для Excel", "color: #4caf50; font-weight: bold;");
      console.log("excelDataTotal:", excelDataTotal);
      console.log("excelData:", excelData);
      console.groupEnd();
    }
  }, [excelDataTotal, excelData]);

  // Массив для мобильного селектора
  const pages = [
    { title: "Финансовый", link: "fin" },
    { title: "По продажам абонементов, пакетов", link: "abon"},
    { title: "По проданным товарам и оказанным услугам", link: "product"}
  ];

  const customTagRender = (props) => {
    return <span className="filters-tag-label">{props.label}</span>;
  };

  const handlePrint = () => {
    setTimeout(() => {
      window.print();
    }, 500);
  };

  const handleExport = () => {
    if (!excelDataTotal && !excelData) {
      message.warning("Нет данных для выгрузки");
      return;
    }
    const tables = [];
    // Добавляем основную таблицу
    if (excelDataTotal?.data?.length) {
      tables.push({
        title: excelDataTotal.title || "Общий отчет",
        colTitle: "Отчёт по продажам абонементов, пакетов",
        columns: excelDataTotal.columns || [],
        data: excelDataTotal.data || []
      });
    }
    // Добавляем детальную таблицу, если есть
    if (excelData?.data?.length) {
      tables.push({
        title: excelData.title || "Детализация",
        colTitle: "Отчёт по продажам абонементов, пакетов",
        columns: excelData.columns || [],
        data: excelData.data || [],
        summary: excelData.summary || []
      });
    }
    if (!tables.length) {
      message.warning("Нет данных для экспорта");
      return;
    }
    exportToExcel(tables, "Отчёт по продажам абонементов, пакетов.xlsx");
  };

  return (
    isMobile ? 
      (
        <>
        <div className='selector-filer-section' style={{marginTop: 0}}>
            <Select value={page} onChange={(v) => { setPage(v); navigate(`/reports?tab=${v}`); }}>
              {pages.map(p => (
                <Select.Option key={p.link} value={p.link}>
                  {p.title}
                </Select.Option>
              ))}
            </Select>
            <img src="/images/filter.svg" alt="filter" onClick={() => {setShowFilter(!showFilter)}}/>
          </div>
          {showFilter && <RepAbonFilter 
            current={filters} 
            periodType={periodType}
            employeeType={employeeType}
            products={products}
            onRefresh={onRefresh}
            onClose={(newFilters) => {
              if (newFilters) {
                onFilterChange(newFilters);
              }
              setShowFilter(false);
            }}
          />}
        </>
      ) :
      (
        <div className="filters-header-padding">
          <div className="filters-row">
            <Select
              allowClear={false}
              value={filters.periodType}
              onSelect={value => onFilterChange({periodType: value})}
              options={periodType}
              className="filters-select"
              defaultValue={periodType[0].label}
            />
            <DatePicker
              value={filters.startDate}
              onChange={value => onFilterChange({startDate: value})}
              format="DD.MM.YYYY"
              allowClear={false}
            />
            <span>по</span>
            <DatePicker
              value={filters.endDate}
              onChange={value => onFilterChange({endDate: value})}
              format="DD.MM.YYYY"
              allowClear={false}
            />
            <div className="prod-names-filter">
              <Select
                allowClear={false}
                value={filters.specificProductIds}
                onSelect={value => onFilterChange({specificProductIds: [...filters.specificProductIds, value]})}
                onDeselect={value => onFilterChange({specificProductIds: filters.specificProductIds.filter(i => i !== value)})}
                onClear={() => onFilterChange({specificProductIds: []})}
                options={products.map(product => ({
                  value: product.id,
                  label: product.name
                }))}
                className="filters-select"
                placeholder="Все"
                tagRender={customTagRender}
                mode="multiple"
                maxTagCount="responsive"
              />
            </div>
             <Select
              allowClear={false}
              value={filters.employeeType}
              onSelect={value => onFilterChange({employeeType: value})}
              options={employeeType}
              className="filters-select"
              placeholder="Все сотрудники"
              tagRender={customTagRender}
            />
            <Button onClick={onRefresh} size={isMobile ? "small" : "middle"}>Обновить</Button>
            <div style={{display: "grid", gridTemplateColumns: "60px 60px", gap:"8px"}}>  
              <PrintButton onClick={handlePrint} />
              <ExportExcelButton onClick={handleExport} />
            </div>
          </div>
        </div>
      )
  );
}

export default RepAbonReportHeader;
